module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAG5JREFUGJWVj7ENgDAQA++9WMg4FBRMwAgIpUBMAyz2oUBIKPoCXFpnW7albJPj5zj0B4HmsnZCSY6fhva5rF0EGdpv5mVUPD/NrWdtuuIZoA1aNAXwhgAUHYj0b/rTmQiKViSUIghgHPqj4lkoXeyuYEONANJQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 1